module.exports = __webpack_public_path__ + "static/media/wg.be870e85.png";